module.exports = __webpack_public_path__ + "media/images/bg-bitcoin1-359cd229a0106e693cc6f4cd7e984360.jpg";